<template>
	<div>
		<el-card>
			<h1 class="title-biaoti">实时通话监控详情</h1>
			<el-row>
				<Video
					v-for="(item, ind) in channel"
					:key="ind"
					:channel="item"
					:index="ind"
				></Video>
			</el-row>
			<el-row>
				<el-button @click="Leave" type="warning">返回上一级</el-button>
			</el-row>
		</el-card>
	</div>
</template>
<script>
import Video from '@/components/video'
export default {
	components: {
		Video,
	},
	data() {
		return {
			channel: [], // 房间号
		}
	},
	activated() {
		this.channel = []
		if (this.$route.params.cid) {
			this.channel.push(...this.$route.params.cid)
		}
	},
	mounted() {
		this.channel = []
		if (this.$route.params.cid) {
			this.channel.push(...this.$route.params.cid)
		}
	},
	destroyed() {
		this.channel = []
	},
	methods: {
		Leave() {
			this.channel = []
			this.$router.push({
				path: '/official/video_monitor',
			})
		},
	},
}
</script>
<style lang="scss" scoped>
</style>
